import React from 'react';
import { theme } from 'lib/style';
import styled from 'styled-components/macro';
import {
  CheckboxInput,
  PrimaryButton,
  SelectionHeaderPopup,
} from 'lib/components';
import { MdDeleteForever } from 'react-icons/md';
import BsBoxArrowIcon from 'lib/images/BsBoxArrow';
import { ISelectedItems } from './types';
import { RecentlyDeletedItems } from 'lib/api/recentlyDeletedApi';

const BtnWrapper = styled.div`
  display: flex;
  gap: 19px;
`;

const CounterWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

type Props = {
  selectedItems: ISelectedItems;
  openDeleteModal: () => void;
  restoreModalToOpen: () => void;
  initialData: RecentlyDeletedItems[];
  changeSelectedItems: React.Dispatch<React.SetStateAction<ISelectedItems>>;
};

export const CTAHeader = ({
  selectedItems,
  openDeleteModal,
  restoreModalToOpen,
  initialData,
  changeSelectedItems,
}: Props) => {
  const selectAll = () => {
    const selected = new Map();
    (initialData || []).map((item: any) =>
      selected.set(item.recentlyDeletedItemId, item)
    );
    changeSelectedItems({
      count: selected.size,
      data: new Map(selected),
    });
  };

  const onCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    let { checked } = event.target as HTMLInputElement;
    if (checked) {
      selectAll();
      return;
    }
    changeSelectedItems({
      count: 0,
      data: new Map(),
    });
  };

  return (
    <>
      {!!selectedItems.count && (
        <SelectionHeaderPopup left='208px'>
          <CounterWrapper>
            <CheckboxInput
              blueCheck={true}
              checkGroupIndicator={
                selectedItems.count > 0 &&
                selectedItems.count !== initialData.length
              }
              checked={selectedItems.count === initialData.length}
              ignoreGrayForAllSelect={true}
              grayCheck={true}
              onClick={(event: React.ChangeEvent<HTMLInputElement>) => {
                event.stopPropagation();
              }}
              onChange={onCheckboxChange}
            />
            Items selected: <b>{selectedItems.count}</b>
          </CounterWrapper>
          <BtnWrapper>
            <PrimaryButton
              text={'Delete forever'}
              onClick={openDeleteModal}
              borderRadius={8}
              textColor={theme.palette.tomatoRed}
              backgroundColor='#FEF6F5'
              iconColor={theme.palette.white}
              icon={<MdDeleteForever color={theme.palette.tomatoRed} />}
              iconFontSize={24}
              textPadding={12}
              iconPadding={12}
              height={40}
              isFullWidth={false}
              iconOpacity={1}
            />
            <PrimaryButton
              text={'Restore'}
              onClick={restoreModalToOpen}
              borderRadius={8}
              textColor={theme.palette.white}
              icon={<BsBoxArrowIcon color={theme.palette.white} />}
              textPadding={12}
              iconPadding={12}
              height={40}
              isFullWidth={false}
            />
          </BtnWrapper>
        </SelectionHeaderPopup>
      )}
    </>
  );
};
